/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-11-08 04:00:56
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Banner } from '@shopify/polaris';

type Props = {
  onDismiss: Function,
  message: string
};

class InvalidInputBanner extends Component<Props> {
  render() {
    const { onDismiss, message } = this.props;

    return (
      <Banner status="critical" onDismiss={onDismiss}>
        <p>
          <strong>{message}</strong>
        </p>
      </Banner>
    );
  }
}

export default InvalidInputBanner;
